import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'


const CenteredFontAwesomeIcon = styled(FontAwesomeIcon)`
  margin: auto;
`

export const DownArrow = ({color='var(--white)'}) => {

  return (
    <CenteredFontAwesomeIcon icon={faAngleDown} color={color} size={'2x'} style={{opacity: 0.4}} />
  );
};
